import cx from 'classnames'
import { motion, AnimatePresence } from 'motion/react'
import { useContext } from 'react'
import { SanityContentFragment } from '@data/sanity/queries/types/content'
import { fadeWithSlideAnimation } from '@lib/animate'
import { PageHeroContext } from '@lib/page-hero-context'
import { HeroContent } from './hero'
import ComplexPortableText from '@components/portable-text/complex'

interface HeroCaseVideoCarouselCaseContentProps {
  slideHeroContent?: SanityContentFragment
  isSlideTransition: boolean
  index: number
  activeIndex: number
}

const HeroCaseVideoCarouselCaseContent = ({
  slideHeroContent,
  isSlideTransition,
  index,
  activeIndex,
}: HeroCaseVideoCarouselCaseContentProps) => {
  const { heroCaseVideoCarouselDisabled, caseHeroModule } =
    useContext(PageHeroContext)

  const isActive = activeIndex === index

  return (
    <AnimatePresence initial={false} mode="wait">
      {/* Case carousel item content */}
      {!heroCaseVideoCarouselDisabled && (
        <motion.div
          key={`case-hero-content-closed-${index}`}
          initial="hide"
          animate="show"
          exit="hide"
          variants={fadeWithSlideAnimation}
          className={cx('absolute inset-0', {
            'z-10': !isActive,
            'z-20': isActive,
          })}
        >
          <div
            className={cx(
              'px-4 sm:container absolute bottom-16 sm:bottom-32 lg:bottom-44 inset-x-0',
            )}
          >
            {!!slideHeroContent && (
              <ComplexPortableText
                content={slideHeroContent}
                className={cx(
                  'rc md:max-w-[80%]',
                  `child:transition child:duration-1000`,
                  {
                    'child:opacity-0 child:translate-y-[20px]':
                      !isActive || isSlideTransition,
                    'child:opacity-100 child:translate-y-0':
                      isActive && !isSlideTransition,
                  },
                )}
              />
            )}
          </div>
        </motion.div>
      )}

      {/* Case page hero content */}
      {heroCaseVideoCarouselDisabled && (
        <motion.div
          key={`case-hero-content-open-${index}`}
          initial="hide"
          animate="show"
          exit="hide"
          variants={fadeWithSlideAnimation}
          className={cx('absolute inset-0', {
            'z-10': !isActive,
            'z-20': isActive,
          })}
        >
          {!!caseHeroModule?.content && (
            <HeroContent
              content={caseHeroModule.content}
              contentPosition={caseHeroModule.contentPosition}
              bgType={caseHeroModule.bgType}
            />
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default HeroCaseVideoCarouselCaseContent
